import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import {
  REGULAR_MODAL_BUTTON_WIDTH,
  REGULAR_MODAL_BUTTON_HEIGHT,
} from '@sdk/components/ui/modal/modal.constants';

export const Footer = styled(Row)`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.bodyBg};
  justify-content: flex-end;
`;

export const FooterRegularButtonWrapper = styled(Row)`
  width: ${REGULAR_MODAL_BUTTON_WIDTH}px;
  height: ${REGULAR_MODAL_BUTTON_HEIGHT}px;
`;
